import { render, staticRenderFns } from "./CreatePlan.vue?vue&type=template&id=e6b56476&"
import script from "./CreatePlan.vue?vue&type=script&lang=js&"
export * from "./CreatePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports